export default __webpack_public_path__ + "static/media/stamp_3.7765d210.png";